import React, { memo } from "react";
import { Checkbox, Input } from "antd";

const RenderInput = ({
  index,
  onInputChange,
  keyTitle,
  placeholder,
  value,
  id,
  newId,
  nestedIndex,
  isCheckbox,
}) => {
  if (isCheckbox) {
    return (
      <Checkbox
        key={`checkbox-section-${Math.floor(Math.random() * 10000) + 1}`}
        id={`checkbox-section-${Math.floor(Math.random() * 10000) + 1}`}
        //key={`input-section-${keyTitle}-${id}-${newId}`}
        //id={`input-section-${keyTitle}-${id}-${newId}`}
        name={keyTitle}
        defaultChecked={value}
        onChange={(event) =>
          onInputChange(event, id, newId, nestedIndex, isCheckbox)
        }
      />
    );
  }

  return (
    <>
      <Input
        key={`input-section-${Math.floor(Math.random() * 10000) + 1}`}
        id={`input-section-${Math.floor(Math.random() * 10000) + 1}`}
        // key={`input-section-${keyTitle}-${id}-${newId}`}
        //   id={`input-section-${keyTitle}-${id}-${newId}`}
        name={keyTitle}
        placeholder={placeholder}
        onChange={(event) =>
          onInputChange(event.target, id, newId, nestedIndex)
        }
        defaultValue={value}
        className={!value && "custom-error"}
      />
      <br />
      {!value && <span className="custom-error-message">Required</span>}
    </>
  );
};

export default RenderInput;
